import API from 'util/API';

// Get risks by year
export const getRisks = async (year) => {
  if (!year) {
    const currentYear = new Date().getFullYear();
    year = currentYear;
  }
  
  const response = await API.get(`/risks?year=${year}`);
  return response.data;
};

// Get risk detail by riskId and year
export const getRiskDetail = async (riskId, year) => {
  if (!riskId || !year) {
    throw new Error('Missing riskId or year parameter');
  }
  
  const response = await API.get(`/risks/${riskId}?year=${year}`);
  return response.data && response.data.riskDoc;
};
